import FadeTransitionRouter from "./FadeTransitionRouter"
export default FadeTransitionRouter
